function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.4,
    height: 18.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 9.045,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.09,
    width: 29.4,
    height: 19.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 28.015,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37.94,
    width: 29.4,
    height: 22.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7716666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 49.254999999999995,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.57,
    width: 29.4,
    height: 25.61,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2683333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 73.375,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.18,
    width: 29.4,
    height: 26.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.30125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 99.385,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.59,
    width: 29.4,
    height: 30.55,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 127.86500000000001,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143.15,
    width: 29.4,
    height: 32.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 159.195,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 175.23,
    width: 29.4,
    height: 34.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 192.245,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 209.26,
    width: 29.4,
    height: 34.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 226.60999999999999,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 243.97,
    width: 29.4,
    height: 35.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 261.585,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.2,
    width: 29.4,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 297.03999999999996,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 314.88,
    width: 29.4,
    height: 36.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 333.03,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.17,
    width: 29.4,
    height: 38.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 370.39,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 389.61,
    width: 29.4,
    height: 42.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 410.635,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 431.66,
    width: 29.4,
    height: 43.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 453.24,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 474.82,
    width: 29.4,
    height: 43.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 496.555,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 518.28,
    width: 29.4,
    height: 44.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 540.5749999999999,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 562.87,
    width: 29.4,
    height: 45.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 585.405,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.94,
    width: 29.4,
    height: 45.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 630.7950000000001,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.65,
    width: 29.4,
    height: 46.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.7,
    y: 676.8249999999999,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 0,
    width: 35.8,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.3,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 0,
    width: 36.17,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.52125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 83.285,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.37,
    y: 0,
    width: 37.6,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.17,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.97,
    y: 0,
    width: 38.64,
    height: 38.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.29,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.61,
    y: 0,
    width: 38.78,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.39,
    y: 0,
    width: 39.16,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.96999999999997,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.55,
    y: 0,
    width: 41.15,
    height: 38.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.332222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.125,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.7,
    y: 0,
    width: 41.35,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.332222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.375,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.05,
    y: 0,
    width: 41.59,
    height: 38.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.845,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.64,
    y: 0,
    width: 43.26,
    height: 38.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.27,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.9,
    y: 0,
    width: 43.79,
    height: 38.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.79499999999996,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.69,
    y: 0,
    width: 44.43,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.905,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.13,
    y: 0,
    width: 46.05,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.155,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.17,
    y: 0,
    width: 47.18,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.76,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.36,
    y: 0,
    width: 47.8,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.798
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.26,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.16,
    y: 0,
    width: 47.84,
    height: 38.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.0799999999999,
    y: 19.495,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 38.99,
    width: 48.77,
    height: 38.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 58.24,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 77.49,
    width: 48.77,
    height: 40.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 97.61999999999999,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 117.75,
    width: 48.77,
    height: 40.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 138.1,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 158.45,
    width: 48.77,
    height: 41.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 179.1,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 199.76,
    width: 48.77,
    height: 42.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 220.95,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 242.14,
    width: 48.77,
    height: 42.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 263.34999999999997,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 284.55,
    width: 48.77,
    height: 44.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 306.665,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 328.78,
    width: 48.77,
    height: 49.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.754000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 353.61999999999995,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 378.47,
    width: 48.77,
    height: 49.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.754000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 403.355,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 428.24,
    width: 48.77,
    height: 52.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 454.47,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 480.7,
    width: 48.77,
    height: 53.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 507.29499999999996,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 533.89,
    width: 48.77,
    height: 54.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 561.37,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 588.85,
    width: 48.77,
    height: 55.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 616.485,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 644.12,
    width: 48.77,
    height: 55.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.785,
    y: 672.0600000000001,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 38.99,
    width: 51,
    height: 53.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.67,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.17,
    y: 38.99,
    width: 51.66,
    height: 53.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1659999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.83,
    y: 38.99,
    width: 58.82,
    height: 53.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.24,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.65,
    y: 38.99,
    width: 61.5,
    height: 53.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.4,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.15,
    y: 38.99,
    width: 61.88,
    height: 53.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.09,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.03,
    y: 38.99,
    width: 63.89,
    height: 53.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.988888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.97499999999997,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.92,
    y: 38.99,
    width: 65.93,
    height: 53.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.885,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.85,
    y: 38.99,
    width: 67.86,
    height: 53.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.78,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.71,
    y: 38.99,
    width: 67.89,
    height: 53.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.6550000000001,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.6,
    y: 38.99,
    width: 71.4,
    height: 53.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.988888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.3000000000001,
    y: 65.94,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 92.89,
    width: 68.66,
    height: 58.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.756666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 122.16,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 151.42,
    width: 68.66,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.129999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 181.74499999999998,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 212.08,
    width: 68.66,
    height: 62.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 243.145,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 274.21,
    width: 68.66,
    height: 62.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 305.28999999999996,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 336.37,
    width: 68.66,
    height: 68.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.681999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 370.575,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 404.78,
    width: 68.66,
    height: 68.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 439.13,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 473.48,
    width: 68.66,
    height: 73.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.628888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 510.17,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 546.85,
    width: 68.66,
    height: 76.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 584.99,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 623.14,
    width: 68.66,
    height: 76.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.5,
    y: 661.5699999999999,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 92.89,
    width: 73.44,
    height: 76.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.54,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.27,
    y: 92.89,
    width: 77.08,
    height: 76.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.761666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.81,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.34,
    y: 92.89,
    width: 78.28,
    height: 76.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.938571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.47999999999996,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.62,
    y: 92.89,
    width: 78.5,
    height: 76.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.761666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.87,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.12,
    y: 92.89,
    width: 80.49,
    height: 76.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.938571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.365,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.61,
    y: 92.89,
    width: 82.3,
    height: 76.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.313999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.76,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.91,
    y: 92.89,
    width: 83.09,
    height: 76.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.57125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.4549999999999,
    y: 131.175,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 169.46,
    width: 110.11,
    height: 95.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.875,
    y: 217.20000000000002,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 264.94,
    width: 110.11,
    height: 96.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.875,
    y: 313.405,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 361.87,
    width: 110.11,
    height: 106.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.80666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.875,
    y: 415.29,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 468.71,
    width: 110.11,
    height: 113.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.76375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.875,
    y: 525.305,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 581.89,
    width: 110.11,
    height: 118.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.875,
    y: 640.9449999999999,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.94,
    y: 169.46,
    width: 125.2,
    height: 138.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.54,
    y: 238.815,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.14,
    y: 169.46,
    width: 145.17,
    height: 138.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.72499999999997,
    y: 238.815,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.32,
    y: 169.46,
    width: 172.68,
    height: 138.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.118333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.6600000000001,
    y: 238.815,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.94,
    y: 308.18,
    width: 168.38,
    height: 154.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.418000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.13,
    y: 385.27,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.94,
    y: 462.35,
    width: 168.38,
    height: 237.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.13,
    y: 581.1750000000001,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.32,
    y: 308.18,
    width: 274.68,
    height: 160.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.66,
    y: 388.49,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.32,
    y: 468.8,
    width: 274.68,
    height: 231.2,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.66,
    y: 584.4,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.749e6a36bb2c3e17dbc45e8685d2b507.svg";
export { ForwardRef as ReactComponent };